export class PriceRuleVehicleModel {
    public priceRuleVehicleId: string;
    public vehicleGroupCode: string;
    public vehicleTypeCode: string;
    public vehicleCompositionId: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}